import { createReducer } from '../../utils';
import types from './types';

// the customer initial state is always being initialized on server-side (server/routes/react.js)
export const initialState = {
    // TODO Think of making myFilter { MALE: { }, FEMALE: { } } by default
    // TODO add gender, eventSecrets defaults
    errors: [],
    myFilter: {},
    currency: null,
    showSecondarySubscriptionContianer: true,
    newsletterSubscriptionPending: false,
    newsletterErrorCount: 0,
    newsletterError: false,
    isTrackingOptedIn: true,
};

const ASYNC_ACTION_HANDLERS = {
    [types.UPDATE_MYFILTER.REQUEST]: state => ({
        ...state,
        myFilterLoading: true
    }),

    [types.UPDATE_MYFILTER.SUCCESS]: (state, action) => ({
        ...state,
        myFilterLoading: false,
        myFilter: action.payload
    }),

    [types.UPDATE_MYFILTER.ERROR]: (state, action) => ({
        ...state,
        myFilterLoading: false,
        errors: [...state.errors, action.payload]
    }),

    [types.FETCH_MYFILTER.REQUEST]: state => ({
        ...state,
        myFilterLoading: true
    }),

    [types.FETCH_MYFILTER.SUCCESS]: (state, action) => ({
        ...state,
        myFilterLoading: false,
        myFilter: action.payload
    }),

    [types.FETCH_MYFILTER.ERROR]: (state, action) => ({
        ...state,
        myFilterLoading: false,
        errors: [...state.errors, action.payload]
    }),

    [types.SUBSCRIBE_TO_NEWSLETTER.REQUEST]: state => ({
        ...state,
        newsletterSubscriptionPending: true,
        newsletterError: false
    }),

    [types.SUBSCRIBE_TO_NEWSLETTER.SUCCESS]: state => ({
        ...state,
        newsletterSubscriptionPending: false,
        newsletterErrorCount: 0,
        newsletterError: false
    }),

    [types.SUBSCRIBE_TO_NEWSLETTER.ERROR]: state => ({
        ...state,
        newsletterSubscriptionPending: false,
        newsletterErrorCount: (state.newsletterErrorCount || initialState.newsletterErrorCount) + 1, // TODO: just a workaround for now
        newsletterError: true
    })
};

const SYNC_ACTION_HANDLERS = {
    [types.UPDATE_NEWSLETTER_ERROR]: (state, action) => ({
        ...state,
        newsletterError: action.payload
    })
};

const ACTION_HANDLERS = {
    ...SYNC_ACTION_HANDLERS,
    ...ASYNC_ACTION_HANDLERS
};

export default createReducer(ACTION_HANDLERS, initialState);
